import BaseController from "../../controller/BaseController";
import JSONModel from "sap/ui/model/json/JSONModel";
import { Button$PressEvent } from "sap/m/Button";
import Filter from "sap/ui/model/Filter";
import FilterOperator from "sap/ui/model/FilterOperator";
import ListBinding from "sap/ui/model/ListBinding";
import { SearchField$LiveChangeEvent } from "sap/m/SearchField";


/**
 * @namespace com.reply.leaviosa.controller
 */
export default class ProjectUsersController extends BaseController {

    public onInit(): void {

    }

    //*************************************************************************************
    // EVENT HANDLERS
    //*************************************************************************************

    onSearchFieldLiveChange(oEvent: SearchField$LiveChangeEvent): void {

        var oBinding = oEvent.getSource().getParent().getParent().getBinding("items") as ListBinding;

        var aFilters = [];
        var sQuery = oEvent.getSource().getValue();

        if (sQuery && sQuery.length > 0) {
            aFilters.push(new Filter("user/firstName", FilterOperator.Contains, sQuery));
            aFilters.push(new Filter("user/lastName", FilterOperator.Contains, sQuery));
            const oCombinedFilter = new Filter({ filters: aFilters, and: false });
            oBinding.filter(oCombinedFilter, "Application");
        } else {
            oBinding.filter([]);
        }

    }
}
